import { IonContent, IonPage, IonButton } from '@ionic/react'
import React, { useState, useEffect } from 'react'
import './Reset.css'
import Input from '../components/Input'
import Toast, { ToastProps } from '../components/Toast'
import { getCodeValue, changePsw } from '../service/api/user'
import { useHistory } from 'react-router'
import { BotIcon, PassShowIcon, PassHideIcon } from '../conf/images'
import { SigninPage } from '../conf/routePath'
import { isPhoneNumber, isPsw } from '../utils'
import message from '../components/Message'

const Logo = () => <img className='logo' src={BotIcon} alt='icon' />

interface FormModel {
    phone: string
    password: string
    code: string
}
interface SiginFormProps {
    value: FormModel
    onChange?: (value: FormModel) => void
}
const ResetForm: React.FC<SiginFormProps> = (props) => {
    const { value, onChange = (value: {}) => undefined } = props
    const [passShow, setPassShow] = useState(false)
    const countItem = Number(localStorage.getItem('count'))
    const [count, setCount] = useState(countItem || 60)
    const [codeFlag, setCodeFlag] = useState(false)

    const getCode = async () => {
        if (!isPhoneNumber(value.phone)) {
            message.error('手机号格式不合法', 3000)
            return
        }
        // 确定手机号是否存在
        // const res = await checkPhone({phone: value.phone})
        const res = await getCodeValue({ phone: value.phone })
        if (res && res.code && res.code !== 200) {
            message.error(res.message || '验证码错误', 3000)
            return
        }
        setCodeFlag(true)
        localStorage.setItem('count', '59')
        setCount(59)
    }
    useEffect(() => {
        if (!codeFlag) return
        const timeId = setTimeout(() => {
            if (count > 1) {
                setCount((c) => c - 1)
                localStorage.setItem('count', (count - 1).toString())
            } else {
                setCodeFlag(false)
                localStorage.removeItem('count')
            }
        }, 1000)
        return () => {
            clearTimeout(timeId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count])
    return (
        <div className='signin-form'>
            <Input
                type='number'
                className='input username'
                value={value.phone}
                onChange={(val) => {
                    onChange({
                        ...value,
                        phone: val.trim(),
                    })
                }}
                placeholder='请输入手机号'
            />
            <Input
                type='number'
                value={value.code}
                className='input code'
                autocomplete='off'
                onChange={(val) => {
                    onChange({
                        ...value,
                        code: val.trim(),
                    })
                }}
                placeholder='请输入验证码'
                suffix={
                    <div>
                        <span className='input-code' onClick={getCode}>
                            {codeFlag
                                ? `${count}秒后重获验证码`
                                : '点击获取验证码'}
                        </span>
                    </div>
                }
            />
            <Input
                type={passShow ? 'text' : 'password'}
                className='input password'
                value={value.password}
                autocomplete='off'
                onChange={(val) =>
                    onChange({
                        ...value,
                        password: val,
                    })
                }
                suffix={
                    <img
                        className='pass-switch'
                        onClick={() => setPassShow(!passShow)}
                        src={passShow ? PassHideIcon : PassShowIcon}
                        alt='icon'
                    />
                }
                placeholder='请输入6-16位密码(至少包含数字和字母)'
            />
        </div>
    )
}

const Reset: React.FC = () => {
    const history = useHistory()
    const [formdata, setFormdata] = useState<FormModel>({
        phone: '',
        password: '',
        code: '',
    })
    const [toastOptions, setToastToastOptions] = useState<ToastProps>({
        isOpen: false,
        message: '',
        position: 'top',
        color: 'error',
        duration: 1500,
    })
    const [formdataValid, setFormdataValid] = useState(false)
    useEffect(() => {
        /** 验证表单输入是否有效 */
        const checkFormDataValid = () => {
            let phoneTrim = formdata.phone.trim()
            let passwordTrim = formdata.password.trim()
            let codeTrim = formdata.code.trim()
            let valid = !!(phoneTrim && passwordTrim && codeTrim)
            return valid
        }
        setFormdataValid(checkFormDataValid())
        setButtonFlag(checkFormDataValid())
    }, [formdata])

    const [buttonFlag, setButtonFlag] = useState(false)
    /** 完成修改 */
    const handleSignIn = async () => {
        if (!isPhoneNumber(formdata.phone)) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '手机号格式不合法',
            })
            return
        }
        if (formdata.code.length !== 6) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '验证码错误',
            })
            return
        }
        if (!isPsw(formdata.password)) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: '请输入6-16位密码(至少包含数字和字母)',
            })
            return
        }
        setButtonFlag(false)
        try {
            let res = await changePsw(formdata)
            if (!res) return
            setButtonFlag(true)
            if (res && res.status_code && res.status_code !== 200) {
                setToastToastOptions({
                    ...toastOptions,
                    isOpen: true,
                    color: 'error',
                    message: res.message,
                })
                return
            }
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'success',
                message: '修改成功',
            })
            setFormdata({
                phone: '',
                password: '',
                code: '',
            })
            history.replace(SigninPage)
        } catch (error) {
            setToastToastOptions({
                ...toastOptions,
                isOpen: true,
                color: 'error',
                message: error.message,
            })
            setButtonFlag(true)
        }
    }
    return (
        <IonPage className='signin-page'>
            <IonContent className='content' scrollY={false}>
                <Logo />
                <h2>重置密码</h2>
                <ResetForm
                    value={formdata}
                    onChange={(val) => {
                        setFormdata(val)
                    }}
                />
                <IonButton
                    disabled={!buttonFlag}
                    color='primary'
                    className='signin-button'
                    onClick={handleSignIn}
                >
                    {formdataValid && !buttonFlag ? 'loading...' : '完成'}
                </IonButton>
                <Toast
                    {...toastOptions}
                    onClose={() =>
                        setToastToastOptions({ ...toastOptions, isOpen: false })
                    }
                />
            </IonContent>
        </IonPage>
    )
}

export default Reset
